var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"linkedInIcon screen",attrs:{"alt":"View Michael Minor's LinkedIn profile","href":_vm.linkedIn,"target":"_blank"}},[_c('v-icon',{attrs:{"color":"primary","large":_vm.large}},[_vm._v("mdi-linkedin-box")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }